<template>
  <div class="area">
    <div class="title">{{ title }}</div>
    <TableInfo
      :query.sync="spaceData.space"
      :columns.sync="spaceInfoList"
      :colSpan="8"
      :buttonSpan="5"
    ></TableInfo>
    <el-divider></el-divider>
    <template v-if="spaceData.space.leafFlag == 0">
      <div>
        <div class="title" style="margin-bottom: 15px">能耗表</div>
        <vxe-table :data="spaceData.spaceEnergyList" border align="center" header-align="center">
          <vxe-table-column field="energyTypeName" title="水表/电表"></vxe-table-column>
          <vxe-table-column field="energyCode" title="编号"></vxe-table-column>
          <vxe-table-column field="energyMeterTypeName" title="能耗表类型"></vxe-table-column>
        </vxe-table>
      </div>
    </template>

    <div class="title" style="margin-bottom: 15px; margin-top: 15px">租赁信息</div>
    <div v-if="spaceData.space.leafFlag == 0">
      <div
        v-if="spaceData.spaceLease.leaseDTOs != null"
        style="margin-bottom: 15px; margin-top: 15px"
      >
        <vxe-table
          :data="spaceData.spaceLease.leaseDTOs"
          border
          align="center"
          header-align="center"
        >
          <!-- <vxe-table-column field="name" title="空间名称"></vxe-table-column>
          <vxe-table-column field="effectiveStatus" title="空间状态">
            <template #default="{ row }">
              <div>{{ getSpaceState(row) }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="area" title="面积(m²)"></vxe-table-column>
          <vxe-table-column field="leaseStatus" title="租赁状态">
            <template #default="{ row }">
              <div>{{ getLeaseStatusMsg(row.leaseStatus) }}</div>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="contractNo" title="合同编号"></vxe-table-column>
          <vxe-table-column field="customerName" title="客户名称"></vxe-table-column>
          <vxe-table-column field="leaseDateUntil" title="租赁期限">
            <template #default="{ row }">
              <div>{{ getDate(row) }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <div v-else style="margin-bottom: 15px; margin-top: 15px">
      <vxe-table
        border
        align="center"
        header-align="center"
        ref="xTable"
        :data="spaceData.spaceLease.childLeaseDTOs"
      >
        <!-- <vxe-table-column width="120" title="单元（楼栋）数" field="unitsNum"> </vxe-table-column> -->
        <vxe-table-column width="110" title="资产名称" field="assetName"> </vxe-table-column>
        <vxe-table-column width="90" title="单元楼层数" field="floorsNum"> </vxe-table-column>
        <!-- <vxe-table-column
          v-if="spaceData.space.type == '02'"
          field="unitsNum"
          title="单元（楼栋）数"
        ></vxe-table-column>
        <vxe-table-column
          v-if="spaceData.space.type == '02' || spaceData.space.type == '03'"
          field="floorsNum"
          title="楼层数"
        ></vxe-table-column> -->
        <!-- <vxe-table-column title="资产名称" field="name"> </vxe-table-column> -->
        <template>
          <vxe-table-column :key="index" v-for="(i, index) in tableColumn" :title="i.title">
            <vxe-table-column
              :key="index"
              v-for="(item, index) in i.children"
              :title="item.title"
              :field="item.field"
            >
              <template v-slot="{ row }">
                <span v-if="item.field == 'leasedNum'">
                  <a
                    @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                    href="#"
                    style="color: blue; cursor: pointer"
                    >{{ row[item.field] }}</a
                  >
                </span>
                <span v-else-if="item.field == 'beLeasedNum'">
                  <a
                    @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                    href="#"
                    style="color: blue; cursor: pointer"
                    >{{ row[item.field] }}</a
                  >
                </span>
                <span v-else-if="item.field == 'beEffectiveNum'">
                  <a
                    @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                    href="#"
                    style="color: blue; cursor: pointer"
                    >{{ row[item.field] }}</a
                  >
                </span>
                <span v-else-if="item.field == 'expiredNum'">
                  <a
                    @click="openSpaceInfoDialog(item.field, row['spaceNo'])"
                    href="#"
                    style="color: blue; cursor: pointer"
                    >{{ row[item.field] }}</a
                  >
                </span>
                <span v-else>{{ row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </vxe-table-column>
        </template>
      </vxe-table>
      <!-- <vxe-table
        :data="spaceData.spaceLease.childLeaseDTOs"
        border
        align="center"
        header-align="center"
      >
        <vxe-table-column
          v-if="spaceData.space.type == '02'"
          field="unitsNum"
          title="单元（楼栋）数"
        ></vxe-table-column>
        <vxe-table-column
          v-if="spaceData.space.type == '02' || spaceData.space.type == '03'"
          field="floorsNum"
          title="楼层数"
        ></vxe-table-column>
        <vxe-table-column
          v-if="
            spaceData.space.type == '02' ||
            spaceData.space.type == '03' ||
            spaceData.space.type == '04'
          "
          field="spacesNum"
          title="空间数"
        ></vxe-table-column>

        <vxe-table-column field="leasedNum" title="已出租"></vxe-table-column>
        <vxe-table-column field="beLeasedNum" title="待出租"></vxe-table-column>
        <vxe-table-column field="beEffectiveNum" title="待生效"></vxe-table-column>
        <vxe-table-column field="expiredNum" title="已失效"></vxe-table-column>
      </vxe-table> -->
    </div>
    <SpaceInfoDialog
      :showDialog.sync="showSpaceInfoDialog"
      :title="spaceInfoDialogTitle"
      :tableData="spaceInfoDialogData"
      v-if="showSpaceInfoDialog"
      @closeDialog="showSpaceInfoDialog = false"
    />
  </div>
</template>
<script>
  import API from '@/api/property/spaceAssets';
  import mixin from '../mixins/mixin';
  import TableInfo from '../../spaceAudit/component/tableInfo.vue';
  import SpaceInfoDialog from './spaceInfoDialog.vue';

  export default {
    name: 'AssetInformationCard',
    mixins: [mixin],
    props: {
      showAreaData: {
        type: Object,
        default: () => {},
      },
      form: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      TableInfo,
      SpaceInfoDialog,
    },
    computed: {
      title() {
        return this.getTypeTitle(this.spaceData.space.type);
      },
      tableColumn() {
        return [
          // {
          //   field: 'spaceNo',
          //   title: '资产编号',
          //   visible: true,
          // },
          // {
          //   field: 'name',
          //   title: '资产名称',
          //   visible: true,
          // },
          {
            title: '空间',
            children: [
              {
                field: 'spacesNum',
                title: '空间数',
                visible: true,
              },
              {
                field: 'totalSpaceArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '已出租',
            children: [
              {
                field: 'leasedNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalLeasedArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '待出租',
            children: [
              {
                field: 'beLeasedNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalBeLeasedArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '待生效',
            children: [
              {
                field: 'beEffectiveNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalBeEffectiveArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
          {
            title: '已失效',
            children: [
              {
                field: 'expiredNum',
                title: '数量',
                visible: true,
              },
              {
                field: 'totalExpiredArea',
                title: '面积(㎡)',
                visible: true,
              },
            ],
          },
        ];
      },
    },
    watch: {
      showAreaData: {
        handler: function (newVal) {
          if (newVal.id != null) {
            this.getSpaceDetail();
          }
        },
        deep: true,
      },
    },
    data() {
      return {
        spaceData: { space: {}, spaceLease: {} },
        spaceInfoList: [],
        spaceInfoDialogTitle: '',
        spaceInfoDialogData: [],
        showSpaceInfoDialog: false,
        getDate(row) {
          console.log('row', row);
          if (row.leaseDateFrom == null || row.leaseDateUntil == null) {
            return '';
          }
          return (
            row.leaseDateFrom.split(' ')[0].replace(/-/g, '.') +
            ' - ' +
            row.leaseDateUntil.split(' ')[0].replace(/-/g, '.')
          );
        },
        getSpaceState(row) {
          console.log('row', row);
          return this.getEffectiveStatusMsg(row['effectiveStatus']);
        },
      };
    },
    mounted() {
      this.getSpaceDetail();
    },
    methods: {
      openSpaceInfoDialog(field, spaceNo) {
        let spaceInfo = this.spaceData.spaceLease.childLeaseDTOs.filter(
          (item) => item.spaceNo == spaceNo
        );
        if (field == 'leasedNum') {
          console.log('11111111');
          this.spaceInfoDialogTitle = '已出租';
          this.spaceInfoDialogData =
            spaceInfo[0].leasedSpaces != null ? spaceInfo[0].leasedSpaces : [];
        } else if (field == 'beLeasedNum') {
          this.spaceInfoDialogTitle = '待出租';
          this.spaceInfoDialogData =
            spaceInfo[0].beLeasedSpaces != null ? spaceInfo[0].beLeasedSpaces : [];
        } else if (field == 'beEffectiveNum') {
          this.spaceInfoDialogTitle = '待生效';
          this.spaceInfoDialogData =
            spaceInfo[0].beEffectiveSpaces != null ? spaceInfo[0].beEffectiveSpaces : [];
        } else if (field == 'expiredNum') {
          this.spaceInfoDialogTitle = '已失效';
          this.spaceInfoDialogData =
            spaceInfo[0].expiredSpaces != null ? spaceInfo[0].expiredSpaces : [];
        }
        this.showSpaceInfoDialog = true;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }
          if (index === 1) {
            sums[index] = '合计：';
            return;
          }
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
      },
      cellDBLClickEvent() {},
      //获取公司信息
      getSpaceDetail() {
        if (this.showAreaData.type == '01') {
          return;
        }
        this.$axios.get(API.SPACE + '/' + this.showAreaData.id).then((res) => {
          console.log('getSpaceDetail', res);

          if (res.data.code == '0') {
            this.spaceData = res.data.data;

            console.log('getSpaceDetail', this.spaceData);
            this.resetCondition();
            if (this.spaceData.space == null) {
              this.spaceData.space = {};
            }
            this.spaceData.space.sublevelsMsg = this.getWhetherMsg(this.spaceData.space.leafFlag);
            this.spaceData.space.selfUseFlagMsg = this.getWhetherMsg(
              this.spaceData.space.selfUseFlag
            );
            this.spaceData.space.leaseStatusMsg = this.getLeaseStatusMsg(
              this.spaceData.space.leaseStatus
            );
            this.spaceData.space.auditStatusMsg = this.getAuditStatusMsg(
              this.spaceData.space.auditStatus
            );
            this.spaceData.space.effectiveStatusMsg = this.getEffectiveStatusMsg(
              this.spaceData.space.effectiveStatus
            );
            this.spaceData.space.assetTypeMsg = this.getAssetTypeMsg(
              this.spaceData.space.assetType
            );
            this.spaceData.space.selfOwnedFlagMsg = this.getWhetherMsg(
              this.spaceData.space.selfOwnedFlag
            );

            if (this.spaceData.spaceLease == null) {
              this.spaceData.spaceLease = {};
            }
            if (this.spaceData.spaceLease.childLeaseDTOs == null) {
              this.spaceData.spaceLease.childLeaseDTOs = [];
            } else {
              this.spaceData.spaceLease.childLeaseDTOs =
                this.spaceData.spaceLease.childLeaseDTOs.map((item) => {
                  return {
                    ...item,
                    assetName: this.spaceData.assetName,
                  };
                });
            }
            if (this.spaceData.spaceLease.leaseDTO == null) {
              this.spaceData.spaceLease.leaseDTO = {};
              this.spaceData.spaceLease.leaseDTOList = [];
            } else {
              this.spaceData.spaceLease.leaseDTOList = [this.spaceData.spaceLease.leaseDTO];
            }

            this.$emit('updateCardInfo', JSON.parse(JSON.stringify(this.spaceData)));
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .area {
    margin-left: 20px;
    margin-top: 15px;
    background-color: white;
    // width: 100%;
    .title {
      font-size: 14px;
      color: black;
      margin-left: 10px;
    }
    .elForm ::v-deep .el-form-item__label {
      font-size: 13px;
      width: 50%;
      color: black;
    }
    ::v-deep .el-input {
      width: 250px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      display: flex;
    }
    .el-line {
      margin-left: 10px;
    }
    ::v-deep .el-table th.el-table__cell {
      background-color: #f6f7f9;
    }
    ::v-deep .el-table__footer-wrapper tbody td.el-table__cell,
    .el-table__header-wrapper tbody td.el-table__cell {
      background-color: white;
    }
    ::v-deep .vxe-table .vxe-table--empty-placeholder {
      display: none;
    }
    ::v-deep .vxe-table .vxe-table--empty-block {
      visibility: unset !important;
    }

    .el-table::before {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0px;
    }
    ::v-deep .el-table .el-table__cell {
      text-align: center;
    }
  }
</style>
